import React from 'react';
import {
  Form,
  Input,
  Button,
  Checkbox,
  Icon,
  Alert
} from 'antd';
import {Link} from 'react-router';
import img from '../style/imgs/banner.jpg';
import {APP_TITLE} from '../constants/configValues'
const FormItem = Form.Item;

class LoginForm extends React.Component {
  render() {
    const {fetching, error, onSubmit, form} = this.props;
    const {getFieldDecorator} = form;
    const errorElement = error
      ? <Alert type="error" message={error} banner="banner"/>
      : <div className="error"></div>;
    return (<div className="login">
      <div className="login-form">
        <img src={img} alt="banner" className="banner"/>
        <div className="title">{APP_TITLE}</div>
        {errorElement}
        <Form onSubmit={onSubmit}>
          <FormItem>
            {
              getFieldDecorator('userName', {
                rules: [
                  {
                    required: true,
                    message: 'Phải nhập tài khoản!'
                  }
                ]
              })(<Input prefix={<Icon type = "user" />} placeholder="tài khoản, sđt, email"/>)
            }
          </FormItem>
          <FormItem>
            {
              getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Phải nhập mật khẩu!'
                  }
                ]
              })(<Input prefix={<Icon type = "lock" />} type="password" placeholder='••••••••••'/>)
            }
          </FormItem>
          <FormItem>
            {
              getFieldDecorator('remember', {
                valuePropName: 'checked',
                initialValue: true
              })(<Checkbox>Lưu</Checkbox>)
            }
            <Link to={'/forgot-password'} className="forgot">Quên mật khẩu</Link>
            <Button disabled={fetching} type="primary" htmlType="submit" className="btn-login">
              ĐĂNG NHẬP
            </Button>
            <Link to={'/register'}>Đăng kí</Link>
          </FormItem>
        </Form>
      </div>
    </div>);
  }
}

export default Form.create()(LoginForm)



// WEBPACK FOOTER //
// ./src/components/LoginForm.js